// 9. COMPOSANT POUR L'EN-TÊTE DE MODAL
// components/ui/ModalHeader.tsx
import React from "react";
import { X, type LucideIcon } from "lucide-react";

interface ModalHeaderProps {
  title: string;
  icon: LucideIcon;
  iconColor?: string;
  onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  icon: Icon,
  iconColor = "text-blue-600",
  onClose,
}) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <h4 className="text-xl sm:text-2xl font-bold text-gray-800 flex items-center">
        <div className={`bg-${iconColor.split('-')[1]}-100 p-2 rounded-xl mr-3`}>
          <Icon className={iconColor} size={24} />
        </div>
        {title}
      </h4>
      <button
        onClick={onClose}
        className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
      >
        <X size={20} className="text-gray-500" />
      </button>
    </div>
  );
};